import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import dayjs from 'dayjs'
import { z } from 'zod'
import weekOfYear from 'dayjs/plugin/weekOfYear'
dayjs.extend(weekOfYear)

export const Prd3010SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    lotNo: z.string().optional(),
    partyId: z.string().optional(),
    itemId: z.string().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    mfgDate: z.coerce.date().default(dayjs().toDate()),
    machine: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)
  .transform((values) => ({
    ...values,
    mfgYear: dayjs(values.mfgDate).isoWeekYear(),
    mfgWeek: dayjs(values.mfgDate).isoWeek(),
  }))

export type Prd3010SearchParams = z.infer<typeof Prd3010SearchParamsSchema>

export const ScrapSchema = z.object({
  id: z.number(),
  item: z.object({
    itemId: z.number(),
    isClaimItem: z.boolean(),
    lotNo: z.string(),
    lotDate: z.coerce.date(),
    mold: z.string(),
    partyId: z.number().nullable(),
    unit: z.string(),
  }),
  defectQty: z.number(),
  defectPump: z.number(),
  defectTube: z.number(),
  defectPumpFromPack: z.number(),
  defectTubeFromPack: z.number(),
  overrideQty: z.number().nullable(),
  overridePump: z.number().nullable(),
  overrideTube: z.number().nullable(),
  overridePumpFromPack: z.number().nullable(),
  overrideTubeFromPack: z.number().nullable(),
})

export type ScrapModel = z.infer<typeof ScrapSchema>

export const Prd3010SearchResultModelSchema = z.object({
  id: z.number(),
  deliveryDate: z.coerce.date(),
  deliveryWeekNo: z.number().int(),
  productionDate: z.coerce.date(),
  mfgDate: z.coerce.date(),
  mfgYear: z.number(),
  mfgWeek: z.number(),
  partyId: z.number(),
  partyName: z.string(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  qty: z.number(),
  number: z.string(),
  lotNo: z.string().nullable(),
  productionType: z.string().nullable(),
  machine: z.string().nullable(),
  startDate: z.coerce.date().nullable(),
  endDate: z.coerce.date().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  isTestProduction: z.boolean(),
  durationInMinutes: z.number(),
  hasMfgRecords: z.boolean(),
  isBacklog: z.boolean(),
  isScrapFinalized: z.boolean(),
  scrapFinalizedAt: z.coerce.date(),
  scraps: z.array(ScrapSchema),
  isFgToWarCompleted: z.boolean(),
  isSummarizeScrap: z.boolean(),
  fgToWarQty: z.number(),
})

export type Prd3010SearchResultModel = z.infer<
  typeof Prd3010SearchResultModelSchema
>

export const Prd3010SearchResultSchema = z
  .object({
    data: z.array(Prd3010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Prd3010SearchResult = z.infer<typeof Prd3010SearchResultSchema>
